module.exports = __webpack_public_path__ + "static/media/map-marker-alt-light 1.b9aaf1fd.svg";